import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {AppSettings} from "../app.settings";
import {Base2Service} from "./base2.service";
import {ResponseApi} from "./response/response";
import {Filter} from "./http.service";
import {Response} from "@angular/http";

@Injectable()
export class MyactsService extends Base2Service {
   
    getActsByAgentId(id): Observable<ResponseApi> {
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'acts/all/' + id);
    }
    getActByUUID(id): Observable<ResponseApi>{
    	return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'acts/getAct/' + id);
    }
    checkExistAct(id): Observable<ResponseApi>{
    	return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'acts/checkExistAct/' + id);
    }
}
 